import { PLP_DEFAULT_SORT, type PlpSortByValue } from '@/features/plp/constants';

export function getSidFromSearch(search: string): string | undefined {
  const raw = new URLSearchParams(search).get('sid')?.trim();
  return raw || undefined;
}

export function getSortByFromSearch(search: string): PlpSortByValue {
  const raw = new URLSearchParams(search).get('sortby')?.trim().toLowerCase();
  if (!raw) return PLP_DEFAULT_SORT as PlpSortByValue;
  const exists = (['date_add', 'mostpopular', 'pricelow', 'pricehigh', 'discount'] as PlpSortByValue[]).includes(
    raw as PlpSortByValue,
  );
  return exists ? (raw as PlpSortByValue) : (PLP_DEFAULT_SORT as PlpSortByValue);
}

export function getSearchParamsFromLocation(search: string): { search_query?: string } {
  const search_query = new URLSearchParams(search).get('search_query')?.trim();
  return { search_query: search_query || undefined };
}
